import React from 'react';
import { Row, Col} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import { getOvulationData } from '../../services';
import { ovulationColumns } from '../Columns'
import ovulation from "../../../assets/img/healthTools/ovulation.png";
import HealthcalculatorBtn from "../HealthcalculatorBtn";
import Loader from '../../Loader';
// import { documentsType } from '../../PersonalHealthRecord/configData';
// import { downloadPdf } from '../../../utils'

class Ovulation extends React.Component{

  state = {
    records:[],
    errormsg:null,
    successmsg:null,
    loading:true
  }

  pdfRef = React.createRef();

  async componentDidMount() {
    const response = await getOvulationData();
    this.setState(prevState => ({
      records: response.data.records,
      loading: false
    }))
  }

  generatePdf = () => {
    let { records } = this.state;
    let headers = ["S.No", "Date of finding", "Approx Ovulation", "Fertile Window", "Next Period Start", "Monthly Average Cycle Length"];
    let bodyData = [];
    records.forEach((record, index) => {
      bodyData.push([index+1, record.createdAt, record.approxOvulation, record.fertileWindow, record.nextPeriodStart, record.avgCycleLength])
    })


    import('../../../utils/downloadPdf')
    .then(({downloadPdfTable}) => {
      downloadPdfTable(headers, bodyData)
    })
  }


  render() {
    let { records } = this.state;

    if(this.state.loading) return <Loader />
    return(
      <React.Fragment>
        <Row>
          <Col md={{size : 4}} className="mt-5">
            <div>
              <img src={ovulation} alt="ovulation" width="100%" />
            </div>
          </Col>
          <Col>
            {records.length > 0 ?
              <div ref={this.pdfRef}>
                <BootstrapTable keyField="_id"
                  data={records} 
                  columns={ovulationColumns}
                  bordered={false}
                  headerClasses="tableHeader"
                  wrapperClasses="table-responsive" 
                />
              </div>
              : <div className="text-center"><h5>No records found</h5></div>
            }
          <HealthcalculatorBtn generatePdf={this.generatePdf} link="calculator/ovulation-calculator" isPdf={(records.length > 0)}/>
          </Col>
        </Row>
      </React.Fragment>
    );

  }

}

export default Ovulation




// WEBPACK FOOTER //
// ./src/views/HealthTools/Ovulation/Ovulation.js